<template>
    <v-col align-self="auto" cols="12" xl="3" lg="5" md="6" sm="8">
        <div class="d-block text-center my-6 py-4">
            <img :src="getLogo()" height="60"/>
        </div>

        <v-card elevation="2" class="pa-6 dddark" :loading="loading" :disabled="loading">
            <div class="text-center pt-6 mt-6 mb-3">
                <span class="d-block text-h4 py-2">{{ $t('components.NewPasswordForm.FormTitle') }}</span>
                <span class="d-block text-subtitle-1">{{ $t('components.NewPasswordForm.FormSubtitle') }}</span>
            </div>

            <v-card-text class="pa-6">
                <v-alert v-if="error" dense outlined type="error">{{ error }}</v-alert>

                <v-form ref="form" id="form" v-model="valid" @submit.prevent="savePassword">
                    <v-text-field 
                        solo light
                        v-model="password"
                        class="dd-input"
                        ref="password"
                        :type="showPass ? 'text' : 'password'"
                        :label="$t('components.NewPasswordForm.PasswordLabel')" 
                        :rules="[rules.required, passwordRule]"
                        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showPass = !showPass"/>

                    <v-checkbox v-model="legal" :rules="[rules.required]">
                        <template v-slot:label>
                            <span v-html="$t('components.NewPasswordForm.LegalCheckBox', {
                                'terms': '/terms-and-conditions.pdf',
                                'privacy': '/privacy-policy.pdf'
                            })"></span>
                        </template>
                    </v-checkbox>

                    <v-btn 
                        block
                        type="submit" 
                        form="form" 
                        color="success" 
                        elevation="1" 
                        class="text-h6"
                        style="text-transform: none" 
                        height="56px"
                        :disabled="!valid">
                        {{ $t('components.NewPasswordForm.NewPasswordButton') }}
                    </v-btn>
                </v-form>
            </v-card-text>
            <v-card-actions class="py-6 text-center d-block text-body-2">
                <p>Questions? Contact our <a href="mailto:reporting@getdeardoc.com">support team</a>.</p>
            </v-card-actions>
        </v-card>
    </v-col>
</template>

<script>
import AuthAPI from '@/utils/AuthAPI';
import EventBus from '@/utils/EventBus';

/**
 * NewPasswordForm component includes the required fields and functions to 
 * perform the creation of a personal password process. When an administrator 
 * creates a new customer from the dashboard, AWS Cognito send to the customer 
 * email a temporaly password that allows to him to change it with a new 
 * password. It uses the AuthAPI class to wrap AWS Cognito service.
 */
export default {
    name: 'NewPasswordForm',
    data: () => ({
        valid: true,
        loading: false,
        password: '',
        showPass: false,
        legal: false,
        error: '',
        rules: {
            required: value => !!value || 'Required.'
        }
    }),
    methods: {
        getLogo() {
            const { isDark } = this.$vuetify.theme;
            return isDark ? '/logow.svg' : '/logo.svg';
        },
        passwordRule(value) {
            if (!value || value.length < 8) return this.$t('components.ResetPasswordForm.PasswordFullRequirements');
            else if (!value.match('[a-z]+')) return this.$t('components.ResetPasswordForm.PasswordLowerCaseRequirements');
            else if (!value.match('[A-Z]+')) return this.$t('components.ResetPasswordForm.PasswordUpperCaseRequirements');
            else if (!value.match('[0-9\\W]+')) return this.$t('components.ResetPasswordForm.PasswordNumberSymbolRequirements');
            return true;
        },
        async savePassword() {
            const { user } = this.$route.params;
            const { password } = this;
            this.toggleLoading();

            const [ success, result ] = await AuthAPI.newPassword(user, password);
            if (!success) this.error = result.message;
            else {
                EventBus.$emit("popup", "Password saved successfully!");
                this.$router.push({ name: 'login' });
            }
            
            this.toggleLoading();
        },
        toggleLoading() {
            if (this.loading) {
                this.loading = false;
                this.$refs.password.reset();
            } else this.loading = true;
        }
    }
}
</script>